<script setup lang="ts">
import { Fancybox } from '@fancyapps/ui';
import { computed, ref, watch } from 'vue';

const props = defineProps({
  modalName: {
    type: String,
    default: null,
  },
  containerClass: {
    type: String,
    default: null,
  },
});

const emits = defineEmits<{
  close: []
}>();

const MODAL_INSTANCE_NUMBER = 'FancyModal::modalInstanceNumber';

const shown = defineModel<boolean>('shown');

const instance = ref<Fancybox | null>(null);

const modalNumber = ((window as any)[MODAL_INSTANCE_NUMBER] || 0) + 1;
(window as any)[MODAL_INSTANCE_NUMBER] = modalNumber;

const modalId = computed(
  () => props.modalName || `vue-fancy-modal-${modalNumber}`,
);
watch(
  shown,
  (isShown) => {
    if (isShown) {
      instance.value = Fancybox.show(
        [{ src: `#${modalId.value}`, type: 'inline' }],
        {
          on: {
            close: () => {
              instance.value = null;
              shown.value = false;
              emits('close');
            },
          },
          tpl: {
            closeButton:
              '<button data-fancybox-close class="base-modal__close" aria-label="Закрыть"></button>',
          },
        },
      );
    }
    else {
      instance.value?.close();
    }
  },
  {
    immediate: true,
  },
);

function close() {
  if (instance.value) {
    instance.value.close();
  }
  else {
    shown.value = false;
    emits('close');
  }
}
</script>

<template>
  <teleport to="#fancy-modals">
    <div :id="modalId" class="base-modal" :class="containerClass">
      <div class="base-modal__popup">
        <div class="base-modal__header">
          <p class="reset-text base-modal__title">
            <slot name="heading" />
          </p>
        </div>
        <slot :close="close" />
      </div>
    </div>
  </teleport>
</template>
